import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import MDialog from '../../../atoms/MDialog';
import MButton from '../../../MUI/Button/MButton';
import Dropdown from '../../../atoms/Dropdown';
import LoaderCover from '../../../atoms/LoaderCover';
import { getArizonaNoticeTemplateData } from '../../../../store/slices/cases/caseInformationArizonaSlice';
import AdditionalInformationFormDialog from './AdditionalInformationFormDialog';

const AdditionalInformationDialog = ({ isOpen, onClose, templates, addViolation, caseId }) => {
  const dispatch = useDispatch();
  const [isLoader, setIsLoader] = useState(false);
  const [documentTemplate, setDocumentTemplate] = useState(null);
  const handleClosed = () => {
    setDocumentTemplate(null);
    setIsLoader(false);
  };

  const { fields } = useSelector((state) => state.caseInformationArizona.noticeTemplateData) || {
    fields: [],
  };

  const [isFormOpen, setIsFormOpen] = useState(false);

  const handleCloseForm = () => {
    setIsFormOpen(false);
    onClose();
  };

  const fetchTemplateData = async () => {
    const templateId = documentTemplate.value;
    setIsLoader(true);
    const templateData = await dispatch(getArizonaNoticeTemplateData({ templateId, id: caseId }));
    const templateFields = templateData?.payload?.fields;
    if (templateFields?.length) {
      setIsFormOpen(true);
      setIsLoader(false);
    } else {
      addViolation(documentTemplate?.id)({}, handleCloseForm());
    }
  };

  return (
    <>
      <MDialog
        title="Additional Information"
        isOpen={isOpen}
        onClose={onClose}
        onClosed={handleClosed}
        fullWidth
        maxWidth="sm"
        footerActions={
          <>
            <MButton variant="secondary" size="large" onClick={onClose} disabled={isLoader}>
              Cancel
            </MButton>
            <MButton
              type="submit"
              size="large"
              onClick={fetchTemplateData}
              disabled={!documentTemplate || isLoader}
            >
              Submit
            </MButton>
          </>
        }
      >
        {isLoader && <LoaderCover />}
        <Dropdown
          isColumn
          label="Document for generation"
          placeholder="Choose document template for generation"
          options={templates ?? []}
          value={documentTemplate}
          onChange={setDocumentTemplate}
        />
      </MDialog>
      <AdditionalInformationFormDialog
        isOpen={isFormOpen}
        onClose={handleCloseForm}
        addViolation={addViolation(documentTemplate?.id)}
        fields={fields}
      />
    </>
  );
};

AdditionalInformationDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  templates: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.number,
    }),
  ).isRequired,
  addViolation: PropTypes.func.isRequired,
  caseId: PropTypes.string.isRequired,
};

export default AdditionalInformationDialog;
